import { createSlice } from "@reduxjs/toolkit";

const initialStudentLevelSectionState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  allCourses: [],
  courses: [],
  sections: [],
  studentSections: [],
  registrationInfoIds: [],
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const studentLevelSectionSlice = createSlice({
  name: "studentLevelSection",
  initialState: initialStudentLevelSectionState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getStudents
    studentsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getAllLevelCourses
    allCoursesFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.allCourses =  entities;
    },
    // getLevelCourses
    coursesFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sections = [];
      state.courses =  entities;
    },
    // getLevelSections
    levelSectionsFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sections = entities;
    },
    // getRegistrationInfoIds
    registrationInfoIdsFetched: (state, action) => {
      const { isSuccess, type, ids } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.registrationInfoIds = ids;      
    },  
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanCoursesAndSections
    coursesAndSectionsCleaned: (state) => {
      state.courses = [];
      state.sections = [];
      state.registrationInfoIds = [];
    },
    //cleanStudentLevelSection
    studentLevelSectionStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = [];
    }
  }
});